<script setup lang="ts">
  import { useTemplateRef } from 'vue';
  import type { CompiledForm } from '@record-fill';
  import { FillRenderer, sheetWidthFor, type ChunkEdges } from '@/features/FormBuilder';

  defineProps<{ form: CompiledForm; chunkEdges?: ChunkEdges | null }>();

  const element = useTemplateRef<HTMLElement>('stage');

  defineExpose({ element });
</script>

<template>
  <Teleport to="body">
    <div
      ref="stage"
      class="light-surface fixed top-0 left-[-100000px] bg-white-01 p-8 text-gray-07"
      :style="{ width: `${sheetWidthFor(form.orientation)}px` }"
      aria-hidden="true"
      inert
      data-testid="record-sheet-export-stage"
    >
      <FillRenderer
        :form="form"
        read-only
        :show-highlights="false"
        :show-compiled-issues="false"
        :chunk-edges="chunkEdges ?? null"
      />
    </div>
  </Teleport>
</template>
